import { Box, IconButton, TableCell, TableRow, Theme, Typography } from "@mui/material";
import { KeyboardArrowRight as KeyboardArrowRightIcon } from "@mui/icons-material";
import dayjs from "dayjs";
import { JobVacancy } from "../../types/types";
import "dayjs/locale/nl";
import { useContext } from "react";
import { InSiteContext } from "../../context/InSiteContext";
import { LanguageContext } from "../../context/LanguageContext";

const RecruitmentEntry: React.FC<{ vacancy: JobVacancy }> = ({ vacancy }) => {
  const { strings, currentLang } = useContext(LanguageContext);
  const inSiteUrl = useContext(InSiteContext);
  let displayFormatEndDate = "D MMMM";
  if (vacancy.endDate !== strings.recruitment.unknown) {
    const endDateDifference = dayjs().diff(dayjs(vacancy.endDate), "year");
    displayFormatEndDate = endDateDifference >= 1 || endDateDifference <= 0 ? "D MMMM YYYY" : "D MMMM";
  }
  return (
    <TableRow key={vacancy.id}>
      <TableCell sx={{ pl: 0, pr: 1, verticalAlign: "top" }}>
        <Box>
          <Typography variant="h6">{vacancy.title}</Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography
              variant="h6"
              component={"span"}
              sx={(theme: Theme) => ({
                fontWeight: "bold",
                fontSize: "0.85",
                color:
                  vacancy.type === "Intern" || vacancy.type === "Internal"
                    ? theme.palette.warning.light
                    : theme.palette.info.main,
              })}
            >
              {vacancy.type}
            </Typography>
            <Typography
              variant="h6"
              fontWeight={400}
              component={"span"}
              sx={{
                fontSize: "0.85",
              }}
            >
              - {vacancy.id}
            </Typography>
          </Box>
        </Box>
      </TableCell>
      <TableCell sx={{ px: 1, verticalAlign: "top" }}>
        <Typography variant="h6">
          {vacancy.endDate !== strings.recruitment.unknown
            ? dayjs(vacancy.endDate).locale(currentLang).format(displayFormatEndDate)
            : vacancy.endDate}
        </Typography>
      </TableCell>
      <TableCell sx={{ px: 1, verticalAlign: "top" }}>
        <Typography variant="h6">{vacancy.candidates}</Typography>
      </TableCell>
      <TableCell sx={{ px: 1, verticalAlign: "top" }}>
        <Typography variant="h6">
          {vacancy.reviews}/{vacancy.candidates}
        </Typography>
      </TableCell>
      <TableCell sx={{ px: 1, verticalAlign: "top" }}>
        <Typography variant="h6">{vacancy.responsiblePerson}</Typography>
      </TableCell>
      <TableCell sx={{ pl: 1, pr: 0, verticalAlign: "top" }} align="right">
        <IconButton
          href={`${inSiteUrl}/recruitment?id=${vacancy.id}`}
          target="_blank"
          sx={(theme: Theme) => ({
            bgcolor: theme.palette.warning.light,
            color: "white",
            width: "30px",
            height: "30px",
            borderRadius: "3px",
            "&:hover": {
              bgcolor: theme.palette.warning.main,
            },
          })}
        >
          <KeyboardArrowRightIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

export default RecruitmentEntry;
